<!-- components/CryptoPrice.vue -->
<template>
    <span :class="{ 'fw-bold': priceInBold }" style="white-space: nowrap;">
        <span v-if="isEuro">&euro;&nbsp;</span>{{ formattedAmount }}&nbsp;<span v-if="iconHtml" class="currency-circle" :class="iconClass" v-html="iconHtml"></span>
    </span>
</template>

<script>
    export default {
        name: "CryptoPrice",
        props: {
            coin: {
                type: Object,
                required: true,
                // Verwacht: { amount: number, currencyCode: string }
            },
            priceInBold: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            isEuro() {
                return this.coin.currencyCode === 'EUR';
            },
            formattedAmount() {
                if (this.isEuro) {
                    return this.coin.amount.toFixed(2);
                } else {
                    return this.coin.amount.toFixed(8);
                }
            },
            iconClass() {
                return `bg-currency-${this.coin.currencyCode}`;
            },
            iconHtml() {
                switch (this.coin.currencyCode) {
                    case 'BTC':
                        return `<i class="fa-brands fa-btc"></i>`;
                    case 'LTC':
                        return '&#321;';
                    case 'ETH':
                        return `<i class="fa-brands fa-ethereum"></i>`;
                    case 'DOGE':
                        return `&#272;`;
                    // voeg extra munten toe indien nodig
                    default:
                        return null;
                }
            }
        }
    };
</script>
